/*
 * @Author: Tina Huang
 * @Date: 2024-02-21 13:12:42
 * @LastEditors: Tina Huang
 * @LastEditTime: 2024-03-12 09:46:39
 * @Description:
 */

export const author = {
  name: '阿汪同学',
  desc: '菜鸟前端 ｜ Notion Creator',
  avatar: './assets/avatar.png',
  link: 'https://space.bilibili.com/19225439',
  email: 'httishere0728@gmail.com',
}
